// extracted by mini-css-extract-plugin
export default {"block":"Block_block__AEC1E","title":"Block_title__nMxS2","content":"Block_content__SSzWN"};